import { loginWithOAuth } from '@adornis/authentication/oauth-client/client/loginWithOAuth.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { LogistikRoutes } from '@chancenlogistik/client/routes.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-image.js';
import '@chancenwerk/design/components/cr-sidebar.js';
import { type ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../../../client/components/chancen-component-logout-button.js';
import '../../../client/design/components/cr-tooltip.js';
import logo from '../../assets/logo_chancenlogistik.png';
const version = require('../../../../package.json').version;

/**
 * @customElement logistik-component-sidebar
 */
@customElement('logistik-component-sidebar')
export class LogistikComponentSidebar extends ChemistryLitElement {
  @state() private readonly _currentUser = new RXController(this, currentUser<ChancenwerkUser>());

  size = new WindowSizeController(this);

  override render() {
    return html`
      <cr-sidebar
        ${css({
          maxWidth: !this.size.mobile ? '350px' : 'unset',
        })}
      >
        ${this._logo()}
        <cr-flex> ${this._publicPages()} ${this._authenticatedPages()} </cr-flex>
        ${this._bottomUpperSlot()} ${this._footerButtonsSlot()}

        <cr-flex space="sm" crossaxis-center slot="footer">
          ${!this._currentUser.value
            ? html`
                <cr-button mode="text" ${css({ flex: 1 })} @click=${() => loginWithOAuth({ silent: true })}>
                  <cr-text ${css({ fontSize: '0.8rem', color: this.colors.white })}>
                    Login für Logistikmitarbeitende
                  </cr-text>
                </cr-button>
              `
            : nothing}
          <cr-flex horizontal>
            <cr-text
              ${css({ cursor: 'pointer', color: 'white', fontSize: '0.8rem' })}
              @click=${() => goTo(LogistikRoutes.impress)}
            >
              Impressum
            </cr-text>
            <cr-text ${css({ color: 'white', margin: '0 10px 0 10px' })}>•</cr-text>
            <cr-text
              ${css({ cursor: 'pointer', color: 'white', fontSize: '0.8rem' })}
              @click=${() => goTo(LogistikRoutes.privacy)}
            >
              Datenschutz
            </cr-text>
          </cr-flex>
          <cr-text ${css({ color: 'white', fontSize: '0.8rem' })}>Version: ${version} </cr-text>
        </cr-flex>
      </cr-sidebar>
    `;
  }

  protected _logo() {
    return html`
      <cr-flex
        crossaxis-center
        padding="md"
        slot="logo"
        w100
        @click=${() => setTimeout(() => goTo(LogistikRoutes.landing), 10)}
      >
        <img ${css({ width: '70%', cursor: 'pointer' })} src=${logo} />
      </cr-flex>
    `;
  }

  protected _publicPages() {
    return html`
      <cr-sidebar-item
        icon=" "
        text=${'Bestellen'}
        href="/"
        ${css({ color: 'white' })}
        .validateActive=${currentHref => currentHref === '/'}
      >
      </cr-sidebar-item>
    `;
  }

  protected _authenticatedPages(): Renderable {
    return this._currentUser.value?.hasPermission('LOGIN_LOGISTIK')
      ? html`
          <cr-sidebar-item icon=" " text=${'Terminal'} href=${LogistikRoutes.terminal} ${css({ color: 'white' })}>
          </cr-sidebar-item>
          <cr-sidebar-item icon=" " text=${'Auswertung'} href=${LogistikRoutes.evaluation} ${css({ color: 'white' })}>
          </cr-sidebar-item>
          <!-- <cr-sidebar-item text=${'Schulprofil'} href=${'#'} ${css({
            color: 'white',
          })}> </cr-sidebar-item> -->
          <cr-sidebar-item
            icon=" "
            text=${'Lagerverwaltung'}
            href=${LogistikRoutes.inventory}
            ${css({
              color: 'white',
            })}
          >
          </cr-sidebar-item>
          <cr-sidebar-item
            icon=" "
            text=${'Produktreihenfolgen'}
            href=${LogistikRoutes.orderings}
            ${css({ color: 'white' })}
          >
          </cr-sidebar-item>
          <cr-sidebar-item
            icon=" "
            text=${'Hinzufügen'}
            href=${LogistikRoutes.products}
            ${css({
              color: 'white',
            })}
          >
          </cr-sidebar-item>
          <cr-sidebar-item
            icon=" "
            text=${'Konfiguration'}
            href=${LogistikRoutes.configuration}
            ${css({
              color: 'white',
            })}
          >
          </cr-sidebar-item>
          <cr-sidebar-item
            icon=" "
            text=${'Externe Zugänge'}
            href=${LogistikRoutes.access}
            ${css({
              color: 'white',
            })}
          >
          </cr-sidebar-item>
        `
      : nothing;
  }

  protected _bottomUpperSlot(): Renderable {
    return html`
      <cr-flex slot="bottom-upper" w100 padding="sm">
        <cr-button
          flex
          icon="shopping_cart"
          @click=${async () => {
            goTo(LogistikRoutes.cart);
          }}
        >
          <cr-tooltip>
            <cr-text> Warenkorb </cr-text>
          </cr-tooltip>
        </cr-button>
      </cr-flex>
    `;
  }

  protected _footerButtonsSlot(): Renderable {
    return nothing;
  }
}
